import React, { useState } from "react";
import {
  ShoppingBag,
  CheckCircle2,
  Circle,
  ChevronDown,
  ChevronRight,
  User,
  Plus,
} from "lucide-react";

const INITIAL_ITEMS = [
  { id: 1, label: "Candy / Chocolate", done: false },
  { id: 2, label: "Small Toys / Fidgets", done: false },
  { id: 3, label: "Socks / Toiletries", done: false },
  { id: 4, label: "Gift Cards", done: false },
  { id: 5, label: "Oranges (Tradition)", done: false },
];

const StockingStufferCard = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [items, setItems] = useState(INITIAL_ITEMS);
  const [newItem, setNewItem] = useState("");

  const toggleItem = (id) => {
    setItems(items.map((i) => (i.id === id ? { ...i, done: !i.done } : i)));
  };

  const addItem = (e) => {
    if (e.key === "Enter" && newItem.trim()) {
      setItems([...items, { id: Date.now(), label: newItem, done: false }]);
      setNewItem("");
    }
  };

  const completed = items.filter((i) => i.done).length;
  const total = items.length;

  return (
    <div className="mb-6 border-l-4 border-indigo-400 bg-white rounded-r-xl shadow-sm overflow-hidden transition-all">
      {/* HEADER */}
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        className="p-5 border-b border-stone-100 bg-indigo-50/30 cursor-pointer hover:bg-indigo-50/50 transition-colors flex justify-between items-center"
      >
        <div>
          <div className="flex items-center gap-2 text-indigo-600 mb-1">
            <ShoppingBag className="w-4 h-4" />
            <span className="text-xs font-bold uppercase tracking-widest">
              Ben's Mission
            </span>
          </div>
          <div className="flex items-center gap-3">
            <h2 className="text-lg font-bold text-stone-800">
              🧦 Stocking Stuffers
            </h2>
            <div className="text-xs font-bold text-indigo-600 bg-indigo-50 px-2 py-1 rounded-full border border-indigo-100">
              {completed} of {total} Acquired
            </div>
          </div>
        </div>

        {isExpanded ? (
          <ChevronDown className="w-5 h-5 text-stone-400" />
        ) : (
          <ChevronRight className="w-5 h-5 text-stone-400" />
        )}
      </div>

      {/* CONTENT */}
      {isExpanded && (
        <div className="p-5 animate-in slide-in-from-top-2 duration-200">
          <div className="flex items-center gap-2 mb-4">
            <div className="bg-stone-100 p-1.5 rounded-full">
              <User className="w-3 h-3 text-stone-500" />
            </div>
            <span className="text-xs font-bold text-stone-400 uppercase tracking-widest">
              Owner: Ben
            </span>
          </div>

          <div className="space-y-2">
            {items.map((item) => (
              <div
                key={item.id}
                onClick={() => toggleItem(item.id)}
                className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all ${
                  item.done
                    ? "bg-stone-50 border-stone-100 opacity-60"
                    : "bg-white border-indigo-100 hover:border-indigo-300"
                }`}
              >
                <div
                  className={item.done ? "text-indigo-600" : "text-stone-300"}
                >
                  {item.done ? (
                    <CheckCircle2 className="w-5 h-5" />
                  ) : (
                    <Circle className="w-5 h-5" />
                  )}
                </div>
                <span
                  className={`text-sm font-medium ${
                    item.done ? "text-stone-500 line-through" : "text-stone-700"
                  }`}
                >
                  {item.label}
                </span>
              </div>
            ))}
          </div>

          {/* Add New */}
          <div className="mt-4 flex items-center gap-3 p-2 border-b-2 border-stone-100 focus-within:border-indigo-300 transition-colors">
            <Plus className="w-4 h-4 text-stone-400" />
            <input
              value={newItem}
              onChange={(e) => setNewItem(e.target.value)}
              onKeyDown={addItem}
              placeholder="Add item..."
              className="w-full bg-transparent text-sm focus:outline-none placeholder:text-stone-300"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default StockingStufferCard;
